import SessionCore from '../core/session';
import Config from '../config/index'

export default class Reporter {
	/**
	 * 数据上报
	 * @param indicators 指标
	 * @param urlStackInfo url 堆栈信息
	 * @param envInfo 环境信息
	 * @param reason 原因
	 * @param duration 轮询检测间隔
	 */
	static report (indicators: string, urlStackInfo: Record<string, any>[], envInfo: Record<string, any>, reason: string, duration: number): void {
		const path: string = window.location && window.location.pathname;
		if (!this.checkShouldReport(indicators, path, duration)) return;
		// 记录上报时间
		this.recordReportTime(indicators, path);
		// 数据上报
		const reportInfo = Object.assign({}, envInfo, { urlStackInfo, probableReason: reason });
		this.customIndexReport(indicators, {
			probableReason: reason
		});
		this.customErrorReport(indicators, reportInfo);

		// 仅在 Throne 环境上报自定义指标
		Config.isCunstomReporter && this.customMetricReport(true)
	}
	/**
	 * Cat 自定义指标上报
	 * @param indicators 指标
	 * @param tags 标记
	 */
	static customIndexReport (indicators: string, tags: Record<string, any>): void {
		const metricManager = Config.reporter && Config.reporter.metricManager;
		if (!metricManager) return;
		//  设定指标维度
		metricManager.setTags(tags);

		//可多次调用，上报统一指标值或者不同的指标值
		metricManager.setMetric(indicators, 1);

		//强制上报所有（注意：兼容性处理，Throne 的上报工具不支持 metricManager）
		metricManager && metricManager.report && metricManager.report ();
	}
	/**
	 * Cat 自定义错误上报
	 * @param indicators 指标
	 * @param info 错误信息
	 */
	static customErrorReport (indicators: string, info: Record<string, any>): void {
		if (!Config.reporter || typeof Config.reporter.addError !== 'function') return;
		// 自定义错误上报
		Config.reporter.addError({
			name: indicators,
			msg: info
		}, {
			level: 'warn',
			category: 'jsError'
		});

		// 发送所有错误（注意：兼容性处理，Throne 的上报工具不支持 sendErrors）
		Config.reporter.sendErrors && Config.reporter.sendErrors();
	}
	/**
	 * 上报自定义指标
	 * @param bool {boolean} true 异常 false 正常
	 */
	static customMetricReport (bool: boolean) {
		if (!Config.reporter || typeof Config.reporter.setMetric !== 'function') return;
		const val = !bool ? 0 : 1
		Config.reporter.setMetric('JumpLimit', val)
	}
	/**
	 * 记录上报时间
	 * @param indicators 指标
	 * @param path 页面路径
	 */
	static recordReportTime (indicators: string, path: string): void {
		const key: string = `${path}_${indicators}_ReportedTimeStamp`;
		SessionCore.setItem(key, Date.now());
	}
	/**
	 * 校验是否上报，根据上次上报时间 + 检测周期判断
	 * 若距离上次上报时间 > 检测周期，则上报；否则不上报
	 * @param indicators 指标
	 * @param path 页面路径
	 * @param duration 检测周期
	 */
	static checkShouldReport (indicators: string, path: string, duration: number): boolean {
		const key: string = `${path}_${indicators}_ReportedTimeStamp`;
		const latestReportedTime: number = SessionCore.getItem(key) || 0;
		return Date.now() - latestReportedTime > duration * 1000;
	}
}
